module.exports = __webpack_public_path__ + "img/hero.93a6e77a.jpg";